import { useTranslation } from 'react-i18next';
import { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { SimpleErrorModal } from './SimpleErrorModal';

interface IdNotFoundModalProps {
  setError?: Dispatch<SetStateAction<Error | undefined>>;
}

export const IdNotFoundModal = ({ setError }: IdNotFoundModalProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <SimpleErrorModal
      title={t('id_not_found')}
      description={t('id_not_found_description')}
      buttonText={t('id_not_found_back')}
      buttonAction={() => {
        navigate(-1);
        setError?.(undefined);
      }}
    />
  );
};
